"use client";

import { usePathname } from "next/navigation";

export type NavItem = { readonly href: string; readonly label: string };
/** 主导航：当前页由路径判断，只加 aria-current，不发请求。 */
export function SiteNav({ items }: { items: readonly NavItem[] }) {
  const pathname = usePathname() ?? "/";
  return <nav className="site-nav" aria-label="主导航">{items.map(item => {
    const current = item.href === "/" ? pathname === "/" : pathname === item.href || pathname.startsWith(`${item.href}/`);
    return <a key={item.href} href={item.href} aria-current={current ? "page" : undefined}>{item.label}</a>;
  })}</nav>;
}
